module.exports = import("https://esm.sh/@tiptap/core@2.4.0");;